export default __webpack_public_path__ + "static/media/stars_radiotelescope.3bdac09b.jpg";